import { ChangeDetectionStrategy, Component, inject, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { IonicModule } from '@ionic/angular';
import { GameDetailsModalComponent } from '../../../../../games/src/lib/components/game-details-modal/game-details-modal.component';
import { GameDetailsModel, isPrivateGame, MODAL_TOKEN, ModalProvider } from '@core';
import {
  BadgeModeEnum,
  BottomNavbarComponent,
  GameCardV2Component,
  OrIconComponent,
  PageLayoutComponent,
  TitileNavbarComponent
} from '@ui-components';
import { GetLocationDetailsQueryHandler, GetLocationDetailsQueryResult } from '../../application/handlers';

@Component({
  selector: 'lib-location-details',
  templateUrl: './location-details.component.html',
  styleUrls: ['./location-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    IonicModule,
    BottomNavbarComponent,
    TitileNavbarComponent,
    GameCardV2Component,
    PageLayoutComponent,
    OrIconComponent
  ],
  providers: [GetLocationDetailsQueryHandler]
})
export class LocationDetailsComponent {
  private readonly modalToken: ModalProvider = inject(MODAL_TOKEN);
  private readonly getLocationDetailsQueryHandler: GetLocationDetailsQueryHandler =
    inject(GetLocationDetailsQueryHandler);

  readonly badgeMode: typeof BadgeModeEnum = BadgeModeEnum;

  readonly locationDetails: Signal<GetLocationDetailsQueryResult | undefined> = toSignal(
    this.getLocationDetailsQueryHandler.getDetails()
  );

  openDetails(game: GameDetailsModel): void {
    if (isPrivateGame(game)) return;

    this.modalToken.showModal$({
      component: GameDetailsModalComponent,
      componentProps: { gameId: game.gameId },
      cssClass: 'modal-auto',
      initialBreakpoint: 1,
      breakpoints: [0, 1]
    });
  }
}
